export default __webpack_public_path__ + "static/media/fab-background.7123bd51.png";